module.exports = __webpack_public_path__ + "static/media/emailLogo.e6042acb.webp";